import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import img from '../../assets/images/layouts/avt-01.svg';

// Helper: detect internal routes (unchanged)
function toInternalRoute(url = '') {
  if (!url) return null;
  if (url.startsWith('/')) return url;
  try {
    const u = new URL(url, window.location.origin);
    if (u.origin === window.location.origin) {
      return u.pathname + u.search + u.hash;
    }
  } catch {}
  return null;
}

function Project3() {
  const [data, setData] = useState([]);
  const [viewer, setViewer] = useState({ open: false, src: '', alt: '' });

  // ✅ Fetch from Google Sheets with robust CSV parser
  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await fetch(
          'https://docs.google.com/spreadsheets/d/e/2PACX-1vTdaOvbJ3dZNqynHuUwUWYpt2w7Yi09P9imnaLELQdZyRDKcZR9jhPQMWZmaKO1wZwl9rnsnpKHhkLl/pub?output=csv'
        );
        const text = await res.text();

        // ✅ Smarter CSV parser that handles commas & quotes
        const parseCSV = (str) => {
          const rows = [];
          let current = '';
          let inQuotes = false;
          let row = [];

          for (let i = 0; i < str.length; i++) {
            const char = str[i];
            const next = str[i + 1];

            if (char === '"' && inQuotes && next === '"') {
              current += '"'; // escaped quote
              i++;
            } else if (char === '"') {
              inQuotes = !inQuotes; // toggle quoted state
            } else if (char === ',' && !inQuotes) {
              row.push(current);
              current = '';
            } else if ((char === '\n' || char === '\r') && !inQuotes) {
              if (current || row.length > 0) {
                row.push(current);
                rows.push(row);
                current = '';
                row = [];
              }
            } else {
              current += char;
            }
          }
          if (current || row.length > 0) {
            row.push(current);
            rows.push(row);
          }
          return rows.filter((r) => r.length > 1);
        };

        // Convert parsed CSV → JSON array
        const rows = parseCSV(text);
        const headers = rows[0].map((h) => h.trim());
        const dataObjects = rows.slice(1).map((cols) => {
          const obj = {};
          headers.forEach((h, i) => {
            obj[h] = (cols[i] || '').trim();
          });
          return obj;
        });

        console.log('✅ Parsed events (safe):', dataObjects);
        setData(dataObjects);
      } catch (err) {
        console.error('❌ Error loading sheet:', err);
      }
    };

    fetchData();

    // Optional: auto-refresh every 5 minutes (300 000 ms)
    const interval = setInterval(fetchData, 300000);
    return () => clearInterval(interval);
  }, []);

  // ESC key + body scroll lock for modal
  useEffect(() => {
    if (viewer.open) {
      const onKey = (e) => e.key === 'Escape' && setViewer({ open: false, src: '', alt: '' });
      window.addEventListener('keydown', onKey, { passive: true });
      const prevOverflow = document.body.style.overflow;
      document.body.style.overflow = 'hidden';
      return () => {
        window.removeEventListener('keydown', onKey);
        document.body.style.overflow = prevOverflow;
      };
    }
  }, [viewer.open]);

  // Loading fallback
  if (!Array.isArray(data) || data.length === 0) {
    return (
      <section className="nft">
        <div className="container text-center py-5">
          <p style={{ color: '#aaa' }}>Loading events…</p>
        </div>
      </section>
    );
  }

  return (
    <section className="nft">
      <div className="container">
        <div className="row">
          {/* Filters (unchanged) */}
          <div className="col-12">
            <div className="filter">
              <form action="#" className="widget-search">
                <input type="text" placeholder="Search item here..." required="" />
                <Link to="#" className="btn-search">
                  <svg
                    width="21"
                    height="21"
                    viewBox="0 0 21 21"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <circle
                      cx="9.7659"
                      cy="9.76639"
                      r="8.98856"
                      stroke="white"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    ></circle>
                    <path
                      d="M16.0176 16.4849L19.5416 19.9997"
                      stroke="white"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    ></path>
                  </svg>
                </Link>
              </form>
              <div id="category" className="dropdown">
                <Link to="#" className="btn-selector nolink ">
                  All categories
                </Link>
                <ul>
                  <li>
                    <span>All Items</span>
                  </li>
                  <li>
                    <span>Bundles</span>
                  </li>
                </ul>
              </div>
              <div id="buy" className="dropdown">
                <Link to="#" className="btn-selector nolink ">
                  Buy now
                </Link>
                <ul>
                  <li>
                    <span>All Items</span>
                  </li>
                  <li>
                    <span>Bundles</span>
                  </li>
                </ul>
              </div>
              <div id="item" className="dropdown">
                <Link to="#" className="btn-selector nolink ">
                  All item
                </Link>
                <ul>
                  <li>
                    <span>All Items</span>
                  </li>
                  <li>
                    <span>Bundles</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>

          {/* Event cards */}
          {data.map((idx) => {
            const internalRoute = toInternalRoute(idx.rsvpUrl);
            return (
              <div key={idx.id} className="col-xl-3 col-md-6" style={{ display: 'flex' }}>
                <div
                  className="nft-item"
                  style={{ display: 'flex', flexDirection: 'column', width: '100%' }}
                >
                  <div className="card-media" style={{ aspectRatio: '4 / 5', overflow: 'hidden' }}>
                    <button
                      type="button"
                      aria-label="Open image"
                      onClick={() =>
                        setViewer({ open: true, src: idx.imgUrl, alt: idx.title || 'Flyer' })
                      }
                      style={{
                        all: 'unset',
                        cursor: 'zoom-in',
                        display: 'block',
                        width: '100%',
                        height: '100%',
                      }}
                    >
                      <img
                        src={idx.imgUrl}
                        alt={idx.title || 'Flyer'}
                        style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                      />
                    </button>
                  </div>

                  <div className="card-title">
                    <Link
                      to="#"
                      className="h5"
                      style={{
                        display: '-webkit-box',
                        WebkitLineClamp: 2,
                        WebkitBoxOrient: 'vertical',
                        overflow: 'hidden',
                        minHeight: '2.6em',
                      }}
                    >
                      {idx.title}
                    </Link>
                  </div>

                  <div className="meta-info">
                    <div className="author">
                      <div className="avatar">
                        <img src={img} alt={idx.owner || 'Owner'} />
                      </div>
                      <div className="info">
                        <span>Presented by</span>
                        <Link to="#" className="h6">
                          {idx.owner || 'NXTLVL'}
                        </Link>
                        {(idx.venue || idx.date) && (
                          <div className="small" style={{ opacity: 0.8 }}>
                            {idx.venue ? idx.venue : ''}
                            {idx.venue && idx.date ? ' • ' : ''}
                            {idx.date ? idx.date : ''}
                          </div>
                        )}
                      </div>
                    </div>
                    <Link to="#" className="wishlist-button heart">
                      <svg
                        width="13"
                        height="13"
                        viewBox="0 0 13 13"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M11.75 4.3125C11.75 2.86292 10.5256 1.6875 9.01533 1.6875C7.88658 1.6875 6.91708 2.34433 6.5 3.28175C6.08292 2.34433 5.11342 1.6875 3.98408 1.6875C2.475 1.6875 1.25 2.86292 1.25 4.3125C1.25 8.52417 6.5 11.3125 6.5 11.3125C6.5 11.3125 11.75 8.52417 11.75 4.3125Z"
                          stroke="white"
                          strokeWidth="1.5"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                      <span className="number-like">{idx.likes ?? 0}</span>
                    </Link>
                  </div>

                  <div className="card-bottom style-explode" style={{ marginTop: 'auto' }}>
                    <div className="price">
                      <span className="icon-logo-01"></span>
                      <div className="price-details">
                        <span>{idx.labelCaption || 'Guest List'}</span>
                        <h6>{idx.label || 'RSVP Now'}</h6>
                      </div>
                    </div>
                    <div className="button-place-bid">
                      {idx.rsvpUrl ? (
                        internalRoute ? (
                          <Link to={internalRoute} className="sc-button">
                            <span>RSVP</span>
                          </Link>
                        ) : (
                          <a href={idx.rsvpUrl} rel="noopener noreferrer" className="sc-button">
                            <span>RSVP</span>
                          </a>
                        )
                      ) : null}
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>

      {/* --- Modal (image viewer) --- */}
      {viewer.open && (
        <div
          className="nx-lightbox"
          role="dialog"
          aria-modal="true"
          onClick={() => setViewer({ open: false, src: '', alt: '' })}
          style={{
            position: 'fixed',
            inset: 0,
            background: 'rgba(0,0,0,0.9)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '2rem',
            zIndex: 1000,
          }}
        >
          <img
            src={viewer.src}
            alt={viewer.alt}
            onClick={(e) => e.stopPropagation()}
            style={{ maxWidth: '95vw', maxHeight: '90vh', objectFit: 'contain' }}
          />
          <button
            aria-label="Close"
            onClick={(e) => {
              e.stopPropagation();
              setViewer({ open: false, src: '', alt: '' });
            }}
            style={{
              position: 'absolute',
              top: 16,
              right: 16,
              background: 'rgba(255,255,255,0.12)',
              border: 0,
              color: '#fff',
              fontSize: 28,
              lineHeight: 1,
              padding: '6px 12px',
              borderRadius: 8,
              cursor: 'pointer',
            }}
          >
            ×
          </button>
        </div>
      )}
    </section>
  );
}

export default Project3;
